import * as React from "react"
import { AfterPage } from "types/afterjs"
import { Card, Typography, Seo } from "components"
import { Col, Row } from "reactstrap"

interface TermsPage {
	//
}

const TermsPage: AfterPage<TermsPage> = () => {
	return (
		<>
			<Seo
				title="قوانین و مقررات"
				description="کاربر گرامی لطفاً موارد زیر را جهت استفاده بهینه از خدمات و برنامه‌‏های کاربردی مرجع آنتی ویروس ایران به دقت ملاحظه فرمایید"
				path="/terms-conditions"
			/>
			<section>
				<Row>
					<Col lg={12}>
						<Card title="قوانین و مقررات | مرجع آنتی ویروس ایران">
							<Typography component="p">
								<span>
									کاربر گرامی لطفاً موارد زیر را جهت استفاده
									بهینه از خدمات و برنامه‌‏های کاربردی مرجع
									آنتی ویروس ایران به دقت ملاحظه فرمایید.
								</span>
								<br />
								<br />
								<span>
									{" "}
									ورود کاربران به وب‏‌سایت مرجع آنتی ویروس
									ایران هنگام استفاده از پروفایل شخصی،
									طرح‏‌های تشویقی، ویدئوهای رسانه تصویری مرجع
									آنتی ویروس ایران و سایر خدمات ارائه شده توسط
									مرجع آنتی ویروس ایران به معنای آگاه بودن و
									پذیرفتن شرایط و قوانین و همچنین نحوه استفاده
									از سرویس‌‏ها و خدمات مرجع آنتی ویروس ایران
									است. توجه داشته باشید که ثبت سفارش نیز در هر
									زمان به معنی پذیرفتن کامل کلیه شرایط و
									قوانین مرجع آنتی ویروس ایران از سوی کاربر
									است.
								</span>
								<br />
								<br />
								<span>
									{" "}
									لازم به ذکر است شرایط و قوانین مندرج،
									جایگزین کلیه توافق‏‌های قبلی محسوب می‏‌شود.
								</span>
								<br />
								<br />

								<span>
									<strong>قوانین عمومی</strong>
								</span>
								<br />
								<span>
									{" "}
									توجه داشته باشید کلیه اصول و رویه‏‌های مرجع
									آنتی ویروس ایران منطبق با قوانین جمهوری
									اسلامی ایران، قانون تجارت الکترونیک و قانون
									حمایت از حقوق مصرف کننده است و متعاقبا کاربر
									نیز موظف به رعایت قوانین مرتبط با کاربر است.
									در صورتی که در قوانین مندرج، رویه‏‌ها و
									سرویس‏‌های مرجع آنتی ویروس ایران تغییراتی در
									آینده ایجاد شود، در همین صفحه منتشر و به روز
									رسانی می شود و شما توافق می‏‌کنید که استفاده
									مستمر شما از سایت به معنی پذیرش هرگونه تغییر
									است.
								</span>
								<br />
								<br />

								<span>
									<strong>تعریف مشتری یا کاربر</strong>
								</span>
								<br />
								<span>
									{" "}
									مشتری یا کاربر به شخصی گفته می‌شود که با
									اطلاعات کاربری خود که در فرم ثبت نام درج
									کرده است، به ثبت سفارش یا هرگونه استفاده از
									خدمات مرجع آنتی ویروس ایران اقدام نماید.
								</span>
								<br />
								<br />

								<span>
									<strong>ارتباطات الکترونیکی</strong>
								</span>
								<br />
								<span>
									{" "}
									هنگامی که شما از سرویس‌‏ها و خدمات مرجع آنتی
									ویروس ایران استفاده می‏‌کنید، سفارش اینترنتی
									خود را ثبت یا خرید می‏‌کنید و یا به مرجع
									آنتی ویروس ایران ایمیل می‏‌زنید، این
									ارتباطات به صورت الکترونیکی انجام می‏‌شود و
									در صورتی که درخواست شما با رعایت کلیه اصول و
									رویه‏‌ها باشد، شما موافقت می‌‏کنید که مرجع
									آنتی ویروس ایران به صورت الکترونیکی (از طریق
									پست الکترونیکی، سرویس پیام کوتاه و سایر
									سرویس‌های الکترونیکی) به درخواست شما پاسخ
									دهد.
								</span>
								<br />
								<br />
								<span>
									{" "}
									همچنین جهت اطلاع رسانی رویدادها، خدمات و
									سرویس‌های ویژه یا پروموشن‌ها، امکان دارد
									مرجع آنتی ویروس ایران برای اعضای وب سایت
									ایمیل یا پیامک ارسال نماید. در صورتی که
									کاربران تمایل به دریافت اینگونه ایمیل و
									پیامک‌ها نداشته باشند، می‌توانند عضویت
									دریافت خبرنامه مرجع آنتی ویروس ایران را در
									پروفایل خود لغو کنند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									توجه داشته باشید که{" "}
									<strong>50002164004</strong> تنها شماره‌ای
									است که مرجع آنتی ویروس ایران از طریق آن برای
									کاربران و مشتریان خود پیامک (اس ام اس) ارسال
									می‌کند. بنابراین ارسال هرگونه پیامک تحت
									عنوان مرجع آنتی ویروس ایران، با هر شماره
									دیگری تخلف و سوء استفاده از نام مرجع آنتی
									ویروس ایران است و در صورت دریافت چنین
									پیامکی، لطفاً جهت پیگیری قانونی آن را به{" "}
									<strong>Info@antivirus.ir</strong> اطلاع
									دهید. همچنین <strong>50002164004</strong>،
									سامانه ارسال پیامک است که وضعیت پردازش سفارش
									یا رویدادها، خدمات و سرویس‌های ویژه مرجع
									آنتی ویروس ایران را به اطلاع کاربران
									می‌رساند و روشن است که امکان دریافت پیام‌های
									شما از طریق این شماره وجود ندارد.
								</span>
								<br />
								<br />

								<span>
									<strong>سیاست‏‌های رعایت حریم شخصی</strong>
								</span>
								<br />
								<span>
									{" "}
									مرجع آنتی ویروس ایران به اطلاعات خصوصی
									اشخاصى که از خدمات سایت استفاده می‏‌کنند،
									احترام گذاشته و از آن محافظت می‏‌کند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									مرجع آنتی ویروس ایران متعهد می‏‌شود در حد
									توان از حریم شخصی شما دفاع کند و در این
									راستا، تکنولوژی مورد نیاز برای هرچه
									مطمئن‏‌تر و امن‏‌تر شدن استفاده شما از سایت
									را، توسعه دهد. در واقع با استفاده از سایت
									مرجع آنتی ویروس ایران، شما رضایت خود را از
									این سیاست نشان می‏‌دهید.
								</span>
								<br />
								<br />
								<span>
									{" "}
									همه مطالب در دسترس از طریق هر یک از خدمات
									مرجع آنتی ویروس ایران، مانند متن، گرافیک،
									آرم، آیکون دکمه، تصاویر، ویدئوهای تصویری،
									موارد قابل دانلود و کپی، داده‌ها و کلیه
									محتوای تولید شده توسط مرجع آنتی ویروس ایران
									جزئی از اموال مرجع آنتی ویروس ایران محسوب
									می‏‌شود و حق استفاده و نشر تمامی مطالب موجود
									و در دسترس در انحصار مرجع آنتی ویروس ایران
									است و هرگونه استفاده بدون کسب مجوز کتبی، حق
									پیگرد قانونی را برای مرجع آنتی ویروس ایران
									محفوظ می‏‌دارد. علاوه بر این، اسکریپت‌ها، و
									اسامی خدمات قابل ارائه از طریق هر یک از
									خدمات ایجاد شده توسط مرجع آنتی ویروس ایران و
									علائم تجاری ثبت شده نیز در انحصار مرجع آنتی
									ویروس ایران است و هر گونه استفاده با مقاصد
									تجاری پیگرد قانونی دارد. کاربران مجاز به
									بهره‌‏برداری و استفاده از لیست محصولات،
									مشخصات فنی، قیمت و هر گونه استفاده از مشتقات
									وب‏‌سایت مرجع آنتی ویروس ایران و یا هر یک از
									خدمات و یا مطالب، دانلود یا کپی کردن اطلاعات
									با مقاصد تجاری، هر گونه استفاده از داده
									کاوی، روبات، یا روش‌‏های مشابه مانند جمع
									آوری داده‌‏ها و ابزارهای استخراج نیستند و
									کلیه این حقوق به صراحت برای مرجع آنتی ویروس
									ایران محفوظ است. در صورت استفاده از هر یک از
									خدمات مرجع آنتی ویروس ایران، کاربران مسئول
									حفظ محرمانه بودن حساب و رمز عبور خود هستند و
									تمامی مسئولیت فعالیت‌‏هایی که تحت حساب
									کاربری و یا رمز ورود انجام می‏‌پذیرد به عهده
									کاربران است. مرجع آنتی ویروس ایران محصولاتی
									مناسب استفاده افراد زیر 18 سال به فروش
									می‏‌رساند و در صورتی که کاربران از سن ذکر
									شده جوان‌‏تر هستند می‌‏باید با اطلاع والدین
									و یا قیم قانونی، به خرید و پرداخت اقدام
									کنند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									تنها مرجع رسمی مورد تایید ما برای ارتباط با
									شما، پایگاه رسمی این سایت یعنی
									www.antivirus.ir است. ما با هیچ روش دیگری جز
									ارسال نامه از طرف آدرس‏‌های رسمی و تایید شده
									در سایت، با شما تماس نمی‌‏گیریم. وب سایت
									مرجع آنتی ویروس ایران هیچگونه سایت اینترنتی
									با آدرسی غیر از www.antivirus.ir و همچنین،
									هیچ گونه وبلاگ و شناسه در برنامه‏‌های گفتگوی
									اینترنتی همچون Yahoo Messenger یا MSN
									Messenger و غیره ندارد و هیچ ‏گاه با این
									روش‏‌ها با شما تماس نمی‏‌گیرد. کاربران جهت
									برقراری ارتباط، تنها می‏‌توانند از آدرس‌‏های
									ذکر شده در بخش ارتباط با ما استفاده کنند.
								</span>
								<br />
								<br />

								<span>
									<strong>ثبت، پردازش و ارسال سفارش</strong>
								</span>
								<br />
								<span>
									{" "}
									روز کاری به معنی روز شنبه تا پنج شنبه هر
									هفته، به استثنای تعطیلات عمومی در ایران است
									و کلیه سفارش‏‌های ثبت شده در طول روزهای کاری
									و اولین روز پس از تعطیلات پردازش می‌‏شوند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									مرجع آنتی ویروس ایران به مشتریان خود در 7
									روز هفته و 24 ساعت در روز امکان سفارش‌‏گذاری
									می‌‏دهد.
								</span>
								<br />
								<br />
								<span>
									{" "}
									کلیه سفارش‌‏های ثبت شده در سایت مرجع آنتی
									ویروس ایران به وسیله ارسال کد سفارش از طریق
									پیام کوتاه و پیش فاکتور از طریق ایمیل، در صف
									پردازش قرار می‏‌گیرند. مرجع آنتی ویروس ایران
									همواره در ارسال و تحویل کلیه سفارش‌‏های ثبت
									شده، نهایت دقت و تلاش خود را می‏‌نماید. با
									وجود این، در صورتی که موجودی محصولی در مرجع
									آنتی ویروس ایران به پایان برسد، حتی پس از
									اقدام مشتری به سفارش‌‏گذاری، حق کنسل کردن آن
									سفارش و یا استرداد وجه سفارش برای مرجع آنتی
									ویروس ایران محفوظ است و یا مشتری می‏‌تواند
									به جای کالای به اتمام رسیده، محصول دیگری را
									جایگزین کند. همچنین در صورت بروز مشکل در
									پردازش نهایی سبد خرید مانند اتمام موجودی
									کالا یا انصراف مشتری، مبلغ پرداخت شده طی 24
									الی 48 ساعت کاری به حساب مشتری واریز خواهد
									شد.
								</span>
								<br />
								<br />
								<span>
									{" "}
									مرجع آنتی ویروس ایران مجاز است بدون اطلاع
									قبلی نسبت به توقف سفارش‌‏گیری جدید، اقدام و
									فروش خود را متوقف کند و کلیه سفارش‌‏های ثبت
									شده قبل از توقف سفارش‌‏گیری، پردازش و ارسال
									می‌‏شود. حق قطع فروش کلیه و یا بخشی از
									محصولات به هر دلیلی مانند اتمام موجودی کالا
									بدون اطلاع قبلی، برای مرجع آنتی ویروس ایران
									محفوظ است.
								</span>
								<br />
								<br />
								<span>
									{" "}
									کاربران باید هنگام سفارش کالای مورد نظر خود،
									فرم سفارش را با اطلاعات صحیح و به طور کامل
									تکمیل کنند. بدیهی است درصورت ورود اطلاعات
									ناقص یا نادرست، سفارش کاربر قابل پیگیری و
									تحویل نخواهد بود. مشتریان می‌توانند نام،
									آدرس و تلفن شخص دیگری را برای تحویل گرفتن
									سفارش وارد کنند و اگر مبلغ سفارش از پیش
									پرداخت شده باشد، تحویل گیرنده سفارش هنگام
									دریافت کالا باید کارت شناسایی همراه داشته
									باشد.
								</span>
								<br />
								<br />
								<span>
									{" "}
									همچنین، امکان پرداخت در محل برای سفارش‌هایی
									که از طریق باربری ارسال می‌شوند یا مبلغ آنها
									بیشتر از سی میلیون ریال است، وجود ندارد و
									لازم است پیش از ارسال، مبلغ اینگونه سفارش‌ها
									از طریق پرداخت کارت به کارت یا پرداخت
									اینترنتی تسویه شود.
								</span>
								<br />
								<br />

								<span>
									<strong>خسارت در هنگام حمل و نقل</strong>
								</span>
								<br />
								<span>
									{" "}
									مرجع آنتی ویروس ایران همواره نهایت تلاش خود
									را می‏‌کند تا کلیه سفارش‏‌ها در نهایت صحت و
									بدون آسیب به دست مشتریان خود در سراسر کشور
									برسد. با توجه به بسته بندی ایمن و استاندارد
									همه مرسولات، تحویل به هر یک از شرکت‌‏های حمل
									و نقل معتبر به انتخاب کاربر و اعلام بارنامه
									مرسوله (درج در سبد خرید و اطلاع رسانی از
									طریق سرویس پیام کوتاه) به این معنی است که
									بروز هر گونه حادثه در هنگام حمل و تحویل به
									عهده شرکت حمل و نقل است و مرجع آنتی ویروس
									ایران تنها در صورت تایید شرکت حمل کننده
									سفارش و در راستای تسهیل امور پیگیری، خسارت
									را جبران می‌‏کند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									آسیب‏‌های ناشی از حمل و نقل باید در عرض 24
									ساعت کاری پس از تحویل سفارش به خدمات پس از
									فروش مرجع آنتی ویروس ایران اطلاع داده شود و
									کالای آسیب دیده به همراه صورت جلسه رسمی شرکت
									حمل کننده و کلیه متعلقات و فاکتور به خدمات
									پس از فروش مرجع آنتی ویروس ایران ارسال شود.
								</span>
								<br />
								<br />

								<span>
									<strong>
										نقدها، نظرها، ارتباطات و سایر مطالب
									</strong>
								</span>
								<br />
								<span>
									{" "}
									سایت مرجع آنتی ویروس ایران ممکن است دارای
									لینک‏‌هایی به سایت‌های دیگر باشد. این
									سایت‏‌ها تحت کنترل مرجع آنتی ویروس ایران
									نیستند و سایت مرجع آنتی ویروس ایران هیچ
									مسوولیتی در قبال محتویات این سایت‏‌ها شامل
									(و نه محدود به) لینک‏‌های دیگری که ممکن است
									در این سایت‏‌ها باشد ندارد. سایت مرجع آنتی
									ویروس ایران این لینک‏‌ها را برای سهولت شما
									فراهم کرده است و وجود هر یک از این لینک‏‌ها
									به معنی تائید یا هر نوع ارتباط ما با اداره
									کنندگان آنها نیست. سایت‏‌هایى که در آگهی‏‌ها
									یا صفحه‏‌های سایت مرجع آنتی ویروس ایران لینک
									می‏‌شوند را افرادی خارج از مرجع آنتی ویروس
									ایران اداره می‌کنند، بنابراین سایت مرجع آنتی
									ویروس ایران نمی‌‏تواند در مورد آنها ضمانتى
									داشته باشد. شما توافق می‏‌کنید مسوولیت هر
									گونه خسارت و آسیب احتمالی وارده را از طرﻳﻖ
									وﻳﺮوس یا فایل‏‌های مخرب دیگر که می‌تواند
									ناشی از درﻳﺎفت و استفاده از داده‌‏ها و
									فایل‏‌های متعلق به سایت‏‌های لینک شده در
									سایت مرجع آنتی ویروس ایران باشد، خود برعهده
									خواهید داشت.
								</span>
								<br />
								<br />
								<span>
									{" "}
									کاربرانی که قصد ارسال نظر در سایت را دارند،
									حتما قوانین زیر را مد نظر داشته باشند:
								</span>
								<br />
								<br />
								<span>
									{" "}
									۱- بدیهی است که اگر این قوانین در نظرات
									کاربری رعایت نشود، نظر وی تایید نخواهد شد و
									در نتیجه در سایت به نمایش در نخواهد آمد.
								</span>
								<br />
								<br />
								<span>
									{" "}
									با این حال، مرجع آنتی ویروس ایران هیچگونه
									مسئولیتی در قبال صحت یا عدم صحت نظرات منتشر
									شده در این قسمت را ندارد. نمایش نظرات
									کاربران در سایت به هیچ وجه به معنی تایید فنی
									مرجع آنتی ویروس ایران درباره محتویات نظر
									نیست. لذا از کاربران محترم تقاضا می‌شود،
									نظرات را اصل و پایه انتخاب و تصمیم گیری خود
									قرار ندهند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۲- نقد کاربران باید شامل نقاط قوت و ضعف
									محصول در استفاده عملی و تجربه شخصی فرد باشد.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۳- حداقل 800 کاراکتر مطلوب در نقد کاربران
									باید وجود داشته باشد.
								</span>
								<br />
								<br />
								<span>
									{" "}
									مواردی که شامل تعریف کاراکتر مطلوب نمی‌شوند:
								</span>
								<br />
								<br />
								<span>
									{" "}
									- قرار دادن فضای خالی (Space) بیش از حد
									معمول
								</span>
								<br />
								<br />
								<span>
									{" "}
									- کشیدن حروف یا کلمات با استفاده از صفحه
									کلید
								</span>
								<br />
								<br />
								<span> - استفاده ی مکرر از یک حرف یا کلمه</span>
								<br />
								<br />
								<span> - بیان مطلب تکراری با نگارش متفاوت</span>
								<br />
								<br />
								<span>
									{" "}
									لازم به ذکر است که رعایت استاندارد تعداد
									کاراکتر مطلوب برای نقد مناسب ضروری است، لذا
									کاربرانی که نمی‌توانند تعداد کاراکتر مطلوب
									نقدشان را به 800 برسانند، باید در قسمت نظرات
									متن خود را ثبت کنند، در غیر اینصورت امکان
									تایید نقد کمتر از 800 کاراکتر مطلوب در قسمت
									نقد کاربران وجود نخواهد داشت.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۴- برای ارسال نقد، لازم است کاربران تا حد
									ممکن از مبالغه و بزرگنمایی مزایا یا معایب
									محصول خودداری کنند. در غیر اینصورت نقد مورد
									نظر تایید نخواهد شد.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۵- نقد مناسب، نقدی است که فقط معایب یا فقط
									مزایا را در نظر نگیرد. بلکه به طور واقع
									بینانه معایب و مزایای هر محصول را در کنار هم
									بررسی کند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۶- با توجه به تفاوت در سطح محصولات مختلف و
									تفاوت عمده در قیمت‌های آنها، لازم است نقد و
									بررسی هر محصول با توجه به قیمت آن صورت گیرد
									نه به صورت مطلق.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۷- جهت احترام به وقت بازدیدکنندگان سایت و
									نقدها، لازم است نویسندگان نقد مطالب غیر
									ضروری را در نقدشان حذف کرده و تا حد ممکن
									تنها مطالب ضروری و مفید را در نقدشان لحاظ
									کنند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۸- با توجه به ساختار بخش نظرات، از پرسیدن
									سوال یا درخواست راهنمایی در این بخش جدا
									خودداری نمایید.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۹- تنها نظراتی که با حروف و زبان فارسی نوشته
									شده باشند، امکان نمایش در سایت را دارند، لذا
									از نوشتن با حروف انگلیسی یا به زبان انگلیسی
									خودداری نمایید.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۱۰- کاربران ارسال کننده نظر موظف به استفاده
									از ادبیات محترمانه و عدم توهین به دیگر
									کاربران هستند، بدیهی است هرگونه توهین به فرد
									یا افرادی، باعث عدم تایید نظر کاربر می‌شود.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۱۱- قسمت نظرات سایت، با تالارهای گفتگو
									(فروم) متفاوت است، لذا برای حفظ ساختار،
									مباحثی که خارج از چهارچوب این قسمت است و
									حالت بحث و گفتگو دارند، تایید نخواهند شد.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۱۲- تمام کاربران حق دارند نظرات خود را به
									شرط رعایت قوانین، در سایت منتشر کنند، لذا
									حتی اگر نظری را به دور از واقعیت، جانبدارانه
									یا اشتباه یافتید، نباید نظر دهنده را مخاطب
									قرار دهید یا از وی انتقاد نمایید. هر کاربر
									تنها می‌تواند نظر خود را عنوان کند و قضاوت
									را به خوانندگان نظرات واگذار نماید.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۱۳- کاربران سایت می‌توانند برای آگاهی از
									تغییرات قیمت از نمودار تغییر قیمت در سایت
									استفاده نمایند، لذا کاربران به هیچ وجه نباید
									در بخش نظرات مبلغ &rdquo;قیمت&ldquo; را ثبت
									نمایند یا درباره قیمت اظهار نظر کنند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۱۴- از بزرگنمایی یا اغراق درباره نقاط قوت یا
									نقاط ضعف محصول در نظرات خود خودداری کنید.
									بدیهی است تا حد ممکن هرگونه نظر مبالغه آمیز
									یا به دور از واقعیت تایید نخواهد شد.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۱۵- &rdquo;نام کاربری&ldquo; ارسال کنندگان
									نظر باید شامل نام و نام خانوادگی فرد با حروف
									فارسی باشد؛ لذا نظراتی که با نام کاربری غیر
									مجاز ارسال شده باشند، هرچند ناقض دیگر قوانین
									ذکر شده نباشند، تایید نخواهند شد.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۱۶- با توجه به مسئولیت سایت در قبال لینک‌های
									موجود در آن؛ کاربران نباید لینک سایت‌های
									دیگر را در نظرات خود ثبت نمایند. کاربران دقت
									داشته باشند تا جای ممکن از هرگونه لینک دادن
									(فرستادن) کاربران به سایت‌های دیگر خودداری
									نمایند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۱۷- تنها نظراتی که مرتبط با محصول مورد نظر
									باشند، تایید خواهند شد، لذا از مطرح کردن
									بحث‌های متفرقه و غیر مرتبط با محصول خودداری
									نمایید.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۱۸- کاربران می‌توانند نقد خود به هر بخش مرجع
									آنتی ویروس ایران را در قسمت مربوطه اعلام
									نمایند، لذا از نوشتن نقد خود درباره سایت در
									قسمت نظرات خودداری نمایید.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۱۹- کاربران توجه داشته باشند، مسائلی را که
									از آن اطمینان ندارند یا نسبت به آن شک دارند،
									به هیچ وجه در نظرات ثبت ننمایند. و همچنین از
									بازنشر شایعات یا اطلاعات غیر مطمئن درباره
									محصولات جدا خودداری نمایند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۲۰- ثبت اطلاعات ارتباطی شخصی، از جمله شماره
									تلفن یا آدرس ایمیل در قسمت نظرات ممنوع است،
									لذا از ثبت اینگونه اطلاعات ارتباطی در نظرات
									خود خودداری نمایید.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۲۱- لازم است کاربران مطالبی را ثبت نمایند که
									برای بازدیدکنندگان سایت مفید واقع شود و از
									بیان هرگونه مطالب شخصی، غیر مرتبط یا غیر
									ضروری در این بخش خودداری نمایند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۲۲- لازم است کاربران نظرات خود را به صورت
									نگارشی و نه گفتاری ثبت نمایند و از کوتاه
									کردن کلمات یا استفاده از ادبیات محاوره ای تا
									جای ممکن در ثبت نظرات خودداری نمایند.
									استفاده از ادبیات نوشتاری که قابلیت نمایش در
									سایت را داشته باشد، لازمه تایید نظرات
									کاربران است.
								</span>
								<br />
								<br />
								<span>
									{" "}
									۲۳- کاربران در نظر داشته باشند که مرجع آنتی
									ویروس ایران، ویرایش نگارشی نظرات کاربران را
									حق خود می‌داند اما سایر ویرایش‌هایی که برای
									رعایت قوانین ذکر شده انجام می‌شود، قبل از
									ثبت نظر، به اجازه کاربر نیاز خواهد داشت.
								</span>
								<br />
								<br />
								<span>
									{" "}
									همچنین نظراتی که کاربران در خصوص کالا در
									وب¬‌سایت درج کرده‌اند، تجربه یا اطلاعات شخصی
									افراد است و برای آنها و مرجع آنتی ویروس
									ایران مسئولیتی ایجاد نمی‌کند.
								</span>
								<br />
								<br />

								<span>
									<strong>محتوا</strong>
								</span>
								<br />
								<span>
									{" "}
									مرجع آنتی ویروس ایران نهایت تلاش و دقت را در
									راستای ارائه تمامی سرویس‌‏های خود می‏‌کند و
									به منظور تولید محتوا از منابع و مراجع اصیل و
									نیز شرکت‏‌های سازنده محصولات استفاده
									می‏‌کند. لازم به ذکر است مرجع آنتی ویروس
									ایران تضمین نمی‏‌کند که توصیفات محصول و یا
									دیگر مطالب مندرج در سایت عاری از خطا باشد.
									اگر محصول ارائه شده توسط مرجع آنتی ویروس
									ایران دارای هر گونه مغایرت با اطلاعات درج
									شده در سایت است تنها راه حل، استرداد کالا
									قبل از استفاده و در شرایط اولیه است.
								</span>
								<br />
								<br />
								<span>
									{" "}
									وب ‏‌سایت مرجع آنتی ویروس ایران هیچ گونه
									مسوولیتی را در رابطه با حذف شدن صفحه‏‌های
									سایت خود و یا لینک‏‌های مرده نمی‌‏پذیرد.
									سروﻳس‌‏های سایت آن‏گونه که هست ارائه می‏‌شود
									و سایت مرجع آنتی ویروس ایران تحت هیچ شرایطی
									مسوولیت تاخیر یا عدم کارکرد سایت را که
									می‌تواند ناشى از عوامل طبیعى، نیروى انسانی،
									مشکلات اینترنتى، خرابی تجهیزات کامپیوترى،
									مخابراتى و غیره باشد بر عهده ندارد.
								</span>
								<br />
								<br />

								<strong>
									<span>
										© کلیه محتویات سایت مرجع آنتی ویروس
										ایران شامل قانون حق تکثیر شده و به سایت
										مرجع آنتی ویروس ایران تعلق دارد.
									</span>
									<br />
									<br />
								</strong>

								<span>
									<strong>سیاست قیمت گذاری</strong>
								</span>
								<br />
								<span>
									{" "}
									سیاست قیمت‌‏گذاری در مرجع آنتی ویروس ایران
									مبتنی بر اصول مشتری مداری و احترام به حقوق
									مصرف کننده است. قیمت‏‌های ارائه شده برای
									کالاها در مرجع آنتی ویروس ایران قیمت‏‌های
									خرده فروشی است که غالباً توسط تولید‏کننده و
									یا تامین‏‌کننده آن محصول به صورت مصوب تعیین
									شده است و سایر کالاها بر اساس مدل و مشخصات و
									همچنین کالاهای مشابه در بازار تعیین قیمت
									می‌‏شوند.
								</span>
								<br />
								<br />
								<span>
									{" "}
									با نهایت احترام به کاربران و با توجه به طیف
									گسترده سبد محصولات، مرجع آنتی ویروس ایران
									نمی‌تواند قیمت و موجودی نهایی کالاها را قبل
									از سفارش گذاری به صورت قطعی اعلام نماید. در
									مواردی بسیار نادر و در صورت وجود نوسان‌‏هایی
									در بازار و یا اشتباه در قیمت‌‏گذاری، اگر
									سفارشی قابل تحویل نباشد، مرجع آنتی ویروس
									ایران موظف است در اسرع وقت این موضوع را به
									فرد سفارش‌ ‏دهنده اطلاع دهد و سفارش را لغو
									نماید. لازم به ذکر است در صورتی که کالایی پس
									ثبت سفارش شامل کاهش قیمت شود، سفارش به روز
									رسانی و قیمت جدید اعمال می‏‌شود. قیمت کلیه
									محصولات با احتساب مالیات بر ارزش افزوده است
									و مشتری مبلغ جداگانه‌‏ای بابت مالیات و عوارض
									ارزش افزوده پرداخت نمی‏‌کند و هزینه‏‌های
									بسته بندی، ارسال و بیمه حمل کالا بسته به
									شرایط سفارش که در فرم سبد خرید اطلاع‌ ‏رسانی
									می‌‏شود، ممکن است جداگانه محاسبه شود.
								</span>
								<br />
								<br />

								<span>
									<strong>
										طرح تشویقی پیشنهاد شگفت انگیز
									</strong>
								</span>
								<br />
								<span>
									{" "}
									طرح تشویقی شگفت انگیز به منظور ایجاد تجربه
									یک خرید خوب برای کاربران در نظر گرفته شده و
									روزانه در این بخش تعدادی از محصولات با
									تخفیف‏‌هایی بسیار ویژه‏‌تر نسبت به فروش‌‏های
									ویژه درج می‏‌شود که این کالاها تنها برای
									ساعت‏‌هایی امکان سفارش گذاری دارند. در
									مواردی که به دلیل استقبال کاربران موجودی
									کالا زودتر از موعد مقرر به پایان رسد، وضعیت
									کالا به ناموجود تغییر می‏‌کند و امکان سفارش
									گذاری وجود نخواهد داشت. در صورتی که کالایی
									در روز قبل از فروش شگفت انگیز به سبد خرید
									اضافه شود و در هنگام پردازش، کالا در طرح
									شگفت انگیز باشد، قیمت شگفت انگیز اعمال
									می‏‌شود. به دلیل اینکه این طرح تنها یک طرح
									تشویقی خرید (پروموشن) است، مرجع آنتی ویروس
									ایران تعهدی در قبال سفارش‌‏های تعدادی ندارد
									و در صورت امکان فروش تعدادی هماهنگی‌‏های
									لازم انجام می‏‌شود. همچنین، به کالاهایی که
									در این طرح خریداری می‌شوند، دیجی بن تعلق
									نمی‌گیرد. هرینه ارسال سفارش برای بخش شگفت
									انگیز به ازای هر کالا به صورت مجزا و ثابت در
									نظر گرفته می‏‌شود و امکان تغییر ندارد.
								</span>
								<br />
								<br />

								<span>
									<strong>نمایندگی</strong>
								</span>
								<br />
								<span>
									{" "}
									مرجع آنتی ویروس ایران در هیچ نقطه‏‌ای از
									کشور نمایندگی فروش و یا خدمات پس از فروش
									ندارد و کلیه سرویس‌‏ها، تراکنش‏‌های مالی و
									خدمات قابل ارائه از طریق دفتر مرکزی پردازش
									می‏‌شود. لطفاً در صورت مشاهده هر گونه تخلفی
									از این دست، مراتب را جهت پیگرد قانونی به
									روابط عمومی مرجع آنتی ویروس ایران اطلاع
									دهید.
								</span>
								<br />
								<br />

								<span>
									<strong>قوه قهریه</strong>
								</span>
								<br />
								<span>
									{" "}
									تمامی شرایط و قوانین مندرج، در شرایط عادی
									قابل اجرا است و در صورت بروز هرگونه از موارد
									قوه قهریه، مرجع آنتی ویروس ایران هیچ گونه
									مسئولیتی ندارد.
								</span>
								<br />
								<br />

								<span>
									مرجع آنتی ویروس ایران خود را ملزم به رعایت
									حریم شخصی کاربران می‌داند، لطفا در صورت
									مشاهده هرگونه تخلف، مراتب را از طریق
									کانال‏‌های ارتباطی ذکر شده با ما در میان
									بگذارید.
								</span>
							</Typography>
						</Card>
					</Col>
				</Row>
			</section>
		</>
	)
}

export default TermsPage
